export const extensionName = {
  metamask: "METAMASK",
  binanceExtension: "BINANCE_EXTENSION",
  trustWallet: "TRUST_WALLET",
};


/// TIERED SYSTEM
export const TIERED_SYSTEM = {
  BRONZE: {
    level:'Ku-Starters',
    amountStakingRequire: `50,000`,
    stakingLengthRequire: `3 hours before Allocation Round opens`,
    tweetRequire: `Like, Comment & Retweet`,
    guaranteedAllocation:`Yes`,
    poolWeight:`10`,
    uri:`https://kccpad.medium.com/introducing-kccpad-the-peoples-launchpad-2ba930e401bd`,
  },
  SILVER: {
    level:'Ku-Bulls',
    amountStakingRequire: `100,000`,
    stakingLengthRequire: `3 hours before Allocation Round opens`,
    tweetRequire: `Like, Comment & Retweet`,
    guaranteedAllocation:`Yes`,
    poolWeight:`22`,
    uri:`https://kccpad.medium.com/introducing-kccpad-the-peoples-launchpad-2ba930e401bd`,
  },
  GOLD: {
    level:`Ku-Coiners`,
    amountStakingRequire: ` 200,000`,
    stakingLengthRequire: `3 hours before Allocation Round opens`,
    tweetRequire: `None`,
    guaranteedAllocation:`Yes`,
    poolWeight:`48`,
    uri:`https://kccpad.medium.com/introducing-kccpad-the-peoples-launchpad-2ba930e401bd`,
  },
  PLATINUM: {
    level:'Platinum',
    amountStakingRequire: `200,000`,
    stakingLengthRequire: `3 hours before Allocation Round opens`,
    tweetRequire: `None`,
    guaranteedAllocation:`Yes`,
    poolWeight:`145`,
    uri:`https://kccpad.medium.com/introducing-kccpad-the-peoples-launchpad-2ba930e401bd`,
  },
  DIAMOND: {
    level:'Diamond',
    amountStakingRequire: `25000`,
    stakingLengthRequire: `3 hours before Allocation Round opens`,
    tweetRequire: `None`,
    guaranteedAllocation:`Yes`,
    poolWeight:`400`,
    uri:`https://kccpad.medium.com/introducing-kccpad-the-peoples-launchpad-2ba930e401bd`,
  },
  BLUE_DIAMOND: {
    level:'Blue Diamond',
    amountStakingRequire: `75000`,
    stakingLengthRequire: `3 hours before Allocation Round opens`,
    tweetRequire: `None`,
    guaranteedAllocation:`Yes`,
    poolWeight:`700 + Private allocations`,
    uri:`https://kccpad.medium.com/introducing-kccpad-the-peoples-launchpad-2ba930e401bd`,
  },
  
};


//ADVISORS
export const ADVISORS = {
  // JASPER_BYUN:{
  //   name:'JASPER BYUN',
  //   image:'images/JASPER_BYUN.jpeg',
  //   position:'Founder \n \r at Blocksync Ventures',
  //   modal:`#team-popup-1`,
  //   telegram:null,
  //   twitter:null,
  //   linked:null,
  // },
  LESTER_LIM:{
    name:'LESTER LIM',
    image:'images/LESTER_LIM.jpeg',
    position:'Founder at X21 Digital',
    modal:`#team-popup-2`,
    telegram:null,
    twitter:null,
    linked:null
  },
  IAN_FRIEND:{
      name:'IAN FRIEND',
      image:'images/Ian_Friend.jpeg',
      position:'Co-Founder and COO at Ferrum Network',
      modal:`#team-popup-3`,
      telegram:null,
      twitter:null,
      linked:null
  },
  DANISH_CHAUDHRY:{
      name:'DANISH CHAUDHRY',
      image:'images/Danish_Chaudhry.jpg',
      position:'CEO at Bitcoin.com Exchange – Entrepreneur, Startup Advisor, Mentor and Investor',
      modal:`#team-popup-4`,
      telegram:null,
      twitter:null,
      linked:null
  },
  EXNETWORK_CAPITAL:{
    name:'EXNETWORK CAPITAL',
    image:'images/exntc.png',
    position:'Exnetwork Capital is an investment firm focused on funding and incubating blockchain projects.',
    modal:`#team-popup-5`,
    telegram:null,
    twitter:null,
    linked:null
  },
  TIM_FROST:{
    name:'TIM FROST',
    image:'images/TIM_FROST.jpg',
    position:'CEO and Co-founder \r of YIELD App',
    modal:`#team-popup-6`,
    telegram:null,
    twitter:null,
    linked:null
  }

}

export const LEGAL_PARTNER ={
  image:'images/SilkLegal_main_horizontal.png',
  description:`Silk Legal is a boutique law firm specializing in FinTech and Cryptocurrency.  We combine a deep understanding of blockchain technology with an expert knowledge of international regulations to analyze issues, risks and opportunities. Silk Legal is a proud member of Global Digital Finance, the leading global association of digital asset companies advocating for and accelerating the adoption of best practices for digital assets.`
}